<template>
	<main-tabs :links="links">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/fb-contents/context'
					},
					label: '文案'
				}, {
					to: {
						path: '/fb-contents/pixel'
					},
					label: 'Page&Pixel'
				}, {
					to: {
						path: '/fb-contents/category-url'
					},
					label: '品类&URL'
				}, {
					to: {
						path: '/fb-contents/country-language'
					},
					label: '国家&语言'
				}, {
					to: {
						path: '/fb-contents/audience'
					},
					label: 'Audience'
				}, {
					to: {
						path: '/fb-contents/website-country'
					},
					label: '站点&国家'
				}]
			}
		}
	}
</script>

